import React from "react";

const Navbar = ({ user, toggleMode, activeMode, openVideoModal }) => {

  const homeUrl = (user.currentUrl &&  user.currentUrl.includes("http") ) ? user.currentUrl : `https://${user.schoolDomain}${user.currentUrl ?  user.currentUrl : ''  }`
  
  const logoutUrl = (user.currentUrl &&  user.currentUrl.includes("http") ) ? user.currentUrl : `https://${user.schoolDomain}`

  return (
    <div className="navigation navbar navbar-light bg-primary">
      <a
        className="d-none d-xl-block bg-light rounded p-1"
        href={homeUrl}
        target="_parent"
      >
        <img
          src={`https://${user.schoolDomain}/Content/newLogin/img/sb-logo.svg`}
          alt=""
        />
      </a>
      <ul
        className="nav nav-minimal flex-row flex-grow-1 justify-content-between flex-xl-column justify-content-xl-center"
        id="mainNavTab"
        role="tablist"
      >
        <li className="nav-item">
          <a
            href={homeUrl}
            target="_parent"
          >
            <div className="nav-link p-0 py-xl-3">
              <span className="material-icons">home</span>
            </div>
          </a>
        </li>
        {/* <li className="nav-item">
          <div className="nav-link p-0 py-xl-3 active">
            <span className="material-icons">chat</span>
          </div>
        </li> */}

        <li onClick={toggleMode}>
          <div className="nav-link p-0 py-xl-3">
            <span className="material-icons">
              {activeMode === "classic" ? "nights_stay" : "brightness_medium"}
            </span>
          </div>
        </li>
        <li onClick={openVideoModal} className="videoNav">
          <div className="nav-link p-0 py-xl-3">
            <span className="material-icons">video_library</span>
          </div>
        </li>
        <li>
          <a href={logoutUrl} target="_parent">
            <div className="nav-link p-0 py-xl-3">
              <span className="material-icons">logout</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  );
};
export default Navbar;
